import request from "@/utils/request";

//获取banner
function getBanner() {
    return request.get('/cms/content/ac_about_produce_ricetext')
}
//获取关于ip数据
function getAboutIpDataList() {
    return request.get('/cms/section/ac_about_ip')
}
//获取核心数据图片
function getCoreData() {
    return request.get('/cms/content/ac_about_core_img')
}
export default {
    getBanner,
    getAboutIpDataList,
    getCoreData
}